const handleDeleteDocumentFileModalDocCompany = {
  confirm: 'Deseja realmente deletar esse arquivo?',
  title: 'DELETAR ARQUIVO'
};

export default handleDeleteDocumentFileModalDocCompany;
